import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface PropsType {
    value: string;
    maxHeight?: string;
    bottomMore?: string;
    primaryColor?: boolean;
}

const ReadMore = ({ value, maxHeight = '72', bottomMore = '0', primaryColor = false }: PropsType) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const [readMore, setReadMore] = useState(false);
    const [hasOverflow, setHasOverflow] = useState(false);
    const [descriptioElement, setDescriptioElement] = useState<HTMLPreElement | null>(null);

    const style = {
        maxHeight: `${maxHeight}px`,
    };

    const styleSpan = {
        bottom: `${bottomMore}px`,
    };

    useEffect(() => {
        setHasOverflow(descriptioElement ? descriptioElement.offsetHeight < descriptioElement.scrollHeight : false);
    }, [descriptioElement]);

    return (
        <pre className={`read-more${readMore ? '__more' : ''}`} ref={(el) => setDescriptioElement(el)} style={style}>
            {value}
            {hasOverflow && (
                <span className={primaryColor ? 'primary' : ''} onClick={() => setReadMore(!readMore)} style={styleSpan}>
                    {readMore ? strings.READ_LESS : strings.READ_MORE}
                </span>
            )}
        </pre>
    );
};

export default ReadMore;
